// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__TD5bK","list":"BalanceDue_list__2VLMw","listRow":"BalanceDue_listRow__1POaY","total":"BalanceDue_total__1px8i"};